import comp from "./GroupedKeyConceptsView";
export default comp;
